export const MONEY = new Intl.NumberFormat('en-US',{ style:'currency', currency: 'USD'});
export const MONEY_NO_DECIMALS = new Intl.NumberFormat('en-US',{ style:'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0});


// Const paths used by all applications
export const CRBN_TERMS_LINK = "https://crbnpaintball.com/pages/terms-privacy";
export const CRBN_ORANGE_LOGO = "/media/logos/crbn_logo_orange.png";
export const DEALER_LOGO = "/media/logos/DealerLogo.png"; //this is the fixed one with no transparent part on bottom

export const CRBN_LOGO_SQUARE = "/media/logos/crbn_logo_square.png";
export const NOT_FOUND_75X75 = "/media/NOTFOUND_75x75.svg";
export const DEALER_INVOICE_FOOTER_IMAGE = "/media/logos/INVOICE_FOOTER.jpg"
export const DEALER_INVOICE_HEADER_IMAGE = "/media/logos/INVOICE_HEADER.png"

export const PLACEHOLDER_JERSEY_IMAGE = "/media/jersey_placeholder.png";